import http from "../services/http-common";

const get_test = (url) => {
  return http.get(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};


const getAll = (url) => {
  return http.get(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};



const get = (url, id) => {
  return http.get(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const create = (url, data) => {
  return http.post(`${url}`, data, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const autherize = (url, data) => {
  return http.post(`${url}`, data).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const update = (url, id, data) => {
  return http.put(`${url}` + "/" + `${id}`, data, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const remove = (url, id) => {
  return http.delete(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const delete_nursery = (url, id) => {
  return http.delete(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const remove_record = (url, id) => {
  return http.delete(`${url}` + "/" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};


const removeAll = (url) => {
  return http.delete(`${url}` + "/", { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const delete_record = (url) => {
  return http.delete(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const getdoc = (url, id) => {
  return http.get(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
}
const get_unmask = (url, id,loginname) => {
  return http.get(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`,"loginname":loginname } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const getAll_unmask = (url,loginname) => {
  return http.get(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`,"loginname":loginname } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};
const CommonService = {
  get_test,
  getAll,
  get,
  create,
  autherize,
  update,
  remove,
  remove_record,
  removeAll,
  getdoc,
  delete_record,
  delete_nursery,
  get_unmask,
  getAll_unmask
};

export default CommonService;
